import React from 'react'


function Footer() {
  return (
    <div className='fixed mt-12 h-16 inset-x-0 bottom-0 bg-l-green flex justify-center items-center text-d-green'>
        <div className='flex justify-center items-center '>
        Copyright 2021 © <a className='font-bold'target="_blank" href="https://ilhammalabu.github.io/"> Zainabu Malabu</a>
        </div>
        </div>
  )
}

export default Footer